export const DEFAULT_SLIDES_COUNT = {
  default: 2,
  sm: 2,
  md: 3,
  lg: 3,
  xl: 4,
  '2xl': 4
};

export const CHAPTERS_SLIDES_COUNT = {
  default: 1.5,
  sm: 1.5,
  md: 3.5,
  lg: 7,
  xl: 7,
  '2xl': 7
};

export const SERIES_SLIDES_COUNT = {
  default: 1.5,
  sm: 1.5,
  md: 3,
  lg: 5,
  xl: 5,
  '2xl': 5
};

export const TRENDING_AUTHORS_SLIDES_COUNT = {
  default: 4,
  sm: 6,
  md: 7,
  lg: 10,
  xl: 12,
  '2xl': 14
};

export const HOT_PANELS_SLIDES_COUNT = {
  default: 1,
  sm: 1,
  md: 2,
  lg: 2.5,
  xl: 3,
  '2xl': 3.5
};

export const COMMENTS_SLIDES_COUNT = {
  default: 1.5,
  sm: 1.5,
  md: 3,
  lg: 5,
  xl: 5,
  '2xl': 5
};
